import apiTariff from '@/api/tariff'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  data: null
}

export const mutationTypes = {
  deleteTariffStart: '[delete tariff] delete tariff start',
  deleteTariffSuccess: '[delete tariff] delete tariff success',
  deleteTariffFailure: '[delete tariff] delete tariff failure'
}

export const actionTypes = {
  deleteTariff: '[delete tariff] delete tariff'
}

const mutations = {
  [mutationTypes.deleteTariffStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteTariffSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteTariffFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteTariff](context, {id}) {
    context.commit(mutationTypes.deleteTariffStart)
    return new Promise(resolve => {
      apiTariff
        .deleteTariff(id)
        .then(response => {
          context.commit(mutationTypes.deleteTariffSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteTariffFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
